<script>
  import BaseModal from './BaseModal.svelte';
  import Button from '../common/Button.svelte';
  
  export let isOpen = false;
  export let title = '';
  export let submitText = '저장';
  export let cancelText = '취소';
  export let loading = false;
  export let size = 'md';
  export let onSubmit = () => {};
  export let onCancel = () => {};

  function handleSubmit() {
    onSubmit();
  }

  function handleCancel() {
    onCancel();
    isOpen = false;
  }

  function handleClose() {
    if (!loading) {
      handleCancel();
    }
  }
</script>

<BaseModal 
  bind:isOpen 
  {title}
  {size}
  closable={!loading}
  closeOnEscape={!loading}
  closeOnBackdrop={!loading}
  on:close={handleClose}
>
  <form on:submit|preventDefault={handleSubmit}>
    <div class="form-modal-body">
      <slot />
    </div>
  </form>
  
  <div slot="footer" class="form-modal-actions">
    <Button 
      variant="secondary" 
      disabled={loading}
      on:click={handleCancel}
    >
      {cancelText}
    </Button>
    <Button 
      type="submit"
      variant="primary"
      {loading}
      disabled={loading}
      on:click={handleSubmit}
    >
      {submitText}
    </Button>
  </div>
</BaseModal>

<style>
  .form-modal-body {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-lg);
  }

  .form-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-sm);
  }

  /* 반응형 디자인 */
  @media (max-width: 768px) {
    .form-modal-actions {
      flex-direction: column-reverse;
      gap: var(--spacing-xs);
    }
  }

  /* 폼 그룹 스타일 */
  :global(.form-modal-body .form-group) {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
  }

  :global(.form-modal-body .form-group label) {
    font-weight: var(--font-weight-medium);
    color: var(--text-color);
  }

  :global(.form-modal-body .form-group input),
  :global(.form-modal-body .form-group textarea),
  :global(.form-modal-body .form-group select) {
    padding: var(--spacing-sm);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius-md);
    font-size: var(--font-size-base);
    transition: border-color 0.3s ease;
  }

  :global(.form-modal-body .form-group input:focus),
  :global(.form-modal-body .form-group textarea:focus),
  :global(.form-modal-body .form-group select:focus) {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(50, 115, 220, 0.25);
  }

  :global(.form-modal-body .form-group .help-text) {
    font-size: var(--font-size-sm);
    color: var(--text-muted);
  }

  :global(.form-modal-body .form-group .error-text) {
    font-size: var(--font-size-sm);
    color: var(--danger-color);
  }
</style> 